module.exports = __webpack_public_path__ + "img/Czech Republic.4be23d72.svg";